<script setup lang="ts">
  import type { ToastItem } from '@liebherr/patternlib/loader';
  import { onBeforeMount, provide, ref } from 'vue';

  const toast = ref<HTMLPatternlibToastElement>();
  const displayBreakpoint = ref<string>('isDesktop');

  const createToast = async (
    toastMessage: string,
    toastType: ToastItem['type'] = 'warning'
  ) => {
    await toast.value?.createToastItem({
      message: toastMessage,
      showIcon: true,
      type: toastType,
      showUndo: false,
      autoHide: true,
      delay: 6000
    });
  };

  const getDisplayBreakpoint = () => {
    return document.documentElement.getAttribute('breakpoint') ?? 'isDesktop';
  };

  provide('createToast', createToast);

  // Preparation for enabling/disabling prices in the application
  // Since this configuration may happen in the websales portal, the data is loaded from the database rather than from configuration
  // Therefore, the data is provided here instead of being read from env
  const enablePrices = false;
  provide('enablePrices', enablePrices);

  const displayBreakpointObserver = new ResizeObserver(() => {
    if (!document.documentElement.getAttribute('breakpoint')) {
      displayBreakpoint.value = 'isDesktop';
      return;
    }

    displayBreakpoint.value = getDisplayBreakpoint();
  });
  displayBreakpointObserver.observe(document.body);

  onBeforeMount(async () => {
    document.documentElement.setAttribute('data-context', 'portal');
    document.documentElement.setAttribute('data-theme', 'hau');
  });

  displayBreakpoint.value = getDisplayBreakpoint();
  provide('displayBreakpoint', displayBreakpoint);
</script>

<template>
  <router-view></router-view>

  <!-- Toast -->
  <patternlib-toast ref="toast" position="bottom-right"></patternlib-toast>
</template>

<style lang="scss" scoped>
  @import 'modules/@liebherr/patternlib/dist/patternlib/patternlib.css';

  .w-700 {
    max-width: 700px;
  }
</style>
